(() => {
  const placeSharedLiveShows = () => {
    const slot = document.querySelector('[data-live-shows-slot]');
    const section = document.querySelector('#shopify-section-live-shows-new');

    if (slot && section && section.parentElement !== slot) {
      slot.append(section);
    }
  };

  placeSharedLiveShows();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeSharedLiveShows, { once: true });
  }

  document.addEventListener('shopify:section:load', placeSharedLiveShows);
})();
